import BaseAPIService from '../base/base-api-service';
import AddressModel from 'src/model/address.model';

interface IOneTimeAddress {
  city: string;
  country: string;
  latitude: string;
  longitud: string;
  secondary: string;
  state: string;
  street: string;
  streetName: string;
  zipCode: string;
}

class AddressService extends BaseAPIService<AddressModel> {
  public endpoint: string = '/accountapp/v1/addresses';

  constructor() {
    super(AddressModel);
  }

  public getAllAddresses(): Promise<AddressModel[]> {
    return this.getByParams(`${this.endpoint}/all`, {}, {});
  }

  public getDefaultAddress(): Promise<AddressModel> {
    return this.getOneByParams(`${this.endpoint}/default`, {}, {});
  }

  public validateOneTimeAddress(
    addresses: string,
    city: string,
    secondary: string,
    state: string,
    street: string,
    street2: string,
    zipCode: string
  ): Promise<IOneTimeAddress> {
    return this.doRequest({
      baseURL: this.baseURL,
      data: {
        addresses,
        city,
        secondary,
        state,
        street,
        street2,
        zipCode
      },
      method: 'post',
      url: `${this.endpoint}/validation`
    }).then(res => {
      return res.data;
    });
  }
}

const addressServiceInstance = new AddressService();
Object.freeze(addressServiceInstance);

export default addressServiceInstance;
